"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RecordService = void 0;
var _record = require("../controllers/record.controller");
var RecordService = {
  records: _record.config.recordURL + "/records/public/login",
  details: _record.config.recordURL + "/records/public/details",
  forgotPassword: _record.config.recordURL + "/records/public/forgot-passcode/mail",
  expiryMagicLinkPassword: _record.config.recordURL + "/records/public/magic-link/mail",
  emailProvider: _record.config.recordURL + "/records/donors/email",
  publicDetails: _record.config.recordURL + "/records/public",
  metadata: _record.config.recordURL + "/records/render/metadata"
};
exports.RecordService = RecordService;